import i18n from 'utils/i18n'
import type { AdminWineSitesFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationWineSitesFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.merchantCountryFilter),
    filterName: ADMIN_FILTERS_NAME.merchantCountryFilter,
    apiFilterName: ADMIN_FILTERS_KEY.merchantCountryFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.pricePerFilter),
    filterName:
      ADMIN_FILTERS_NAME.pricePerFilter satisfies AdminWineSitesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.pricePerFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.isEshopFilter),
    filterName:
      ADMIN_FILTERS_NAME.isEshopFilter satisfies AdminWineSitesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.isEshopFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.parsingFilter),
    filterName:
      ADMIN_FILTERS_NAME.parsingFilter satisfies AdminWineSitesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.parsingFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineSiteTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineSiteTypeFilter satisfies AdminWineSitesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.wineSiteTypeFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.multiCountryFilter),
    filterName:
      ADMIN_FILTERS_NAME.multiCountryFilter satisfies AdminWineSitesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.multiCountryFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.multiCurrencyFilter),
    filterName:
      ADMIN_FILTERS_NAME.multiCurrencyFilter satisfies AdminWineSitesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.multiCurrencyFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.createdAtFilter satisfies AdminWineSitesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.lastUpdateFilter),
    filterName: ADMIN_FILTERS_NAME.updatedAtFilter,
    apiFilterName: ADMIN_FILTERS_KEY.updatedAtFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.deliveryTimeFilter),
    filterName:
      ADMIN_FILTERS_NAME.deliveryTimeFilter satisfies AdminWineSitesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.deliveryTimeFilter,
  },
]

export const adminWineSitesFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationWineSitesFiltersCollection,
  pathToStore: ['administration'],
  filtersDataPath: ['admin', 'merchants', 'merchantsFilters'],
  showResultsTextKey: 'filters.button.apply',
  showPresets: false,
}
